import { useQuery } from "@tanstack/react-query";
import { uniq } from "lodash";
import { useAddInState } from "@/components/AddInStateProvider";
import { useGeotabClient } from "@/components/GeotabClientContext";
import createUserGroupFilter from "@/utilities/createUserGroupFilter";

/**
 * Returns the users with the given ids.
 *
 * @param ids - The id sof the users.
 * @returns - The array of {@link User}.
 */
export function useUsersByIds(ids?: string[]) {
  const { geotabClient, activeSessionId } = useGeotabClient();
  const { groups, groupFilterCondition } = useAddInState();

  ids = ids ? uniq(ids) : ids;

  return useQuery({
    queryKey: ["users", activeSessionId, ids],

    queryFn: async ({ signal }) => {
      if (!ids) {
        return Promise.resolve(null);
      }

      const users = await Promise.all(
        ids.map(id =>
          geotabClient.get(
            "User",
            createUserGroupFilter(groups, groupFilterCondition, { id }),
            1,
            signal,
          ),
        ),
      );
      return users;
    },

    enabled: !!ids,
  });
}
